export function base64Decode(productId: string) {
  if (isBase64(productId)) {
    return atob(productId);
  }
  return productId;
}

export function isBase64(str: string) {
  try {
    return btoa(atob(str)) === str;
  } catch {
    return false;
  }
}

export function sanitizeProduct(product: any) {
  if (product === null) {
    return product;
  }

  const {variants} = product;
  if (!variants) return product;
  return {
    ...product,
    variants: {
      ...variants,
      edges: variants.edges.map((edge: any) => {
        return {
          node: {
            ...edge.node,
            id: base64Decode(edge.node.id),
          },
        };
      }),
    },
    id: base64Decode(product.id),
  };
}
